import { Effect } from "../../Materials/effect";
var name = 'pbrBlockLightmapInit';
var shader = "#ifdef LIGHTMAP\nvec4 lightmapColor=texture2D(lightmapSampler,vLightmapUV+uvOffset);\n#ifdef RGBDLIGHTMAP\nlightmapColor.rgb=fromRGBD(lightmapColor);\n#endif\n#ifdef GAMMALIGHTMAP\nlightmapColor.rgb=toLinearSpace(lightmapColor.rgb);\n#endif\nlightmapColor.rgb*=vLightmapInfos.y;\n#endif\n";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var pbrBlockLightmapInit = { name: name, shader: shader };
//# sourceMappingURL=pbrBlockLightmapInit.js.map